module.exports = __webpack_public_path__ + "static/media/header.8004ab8d.jpg";